import React from 'react';
import { Card, SelectLabel } from '@weezevent/nacre';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { getLanguageOptions, LANGUAGES_CODES } from '../../../nacre/components/LanguageSelector';
import Style from './module-display.module.css';

const Language = ({ formModuleDisplay, setFormModuleDisplay, languages, translateIdtoChoice, setDefaultLanguage }) => {
    const { t } = useTranslation();
    const languageOptions = getLanguageOptions();
    const [language, setLanguage] = React.useState(translateIdtoChoice(formModuleDisplay.id_langue));
    const translateLanguageOptionsToId = change => {
        return LANGUAGES_CODES[change];
    };
    const filterOptionLanguage = () => {
        if (languages) {
            return languageOptions.filter(obj => languages.indexOf(obj.value.toLowerCase()) !== -1 || obj.value === 'it-IT');
        }

        return [];
    };
    return (
        <Card.FormStep title={t('ticket.ticket_option.module.language.title')} id={'language'} rightComponent>
            <div className={Style['language-selector']}>
                <SelectLabel
                    key="language_selector"
                    label={t('ticket.ticket_option.module.language.LanguageLabel')}
                    onChange={change => {
                        const lang_id = translateLanguageOptionsToId(change);
                        setLanguage(change);
                        setDefaultLanguage(change);
                        setFormModuleDisplay('id_langue', lang_id);
                    }}
                    options={filterOptionLanguage()}
                    placeholder={t('ticket.common.language')}
                    value={language}
                    useNew
                />
            </div>
        </Card.FormStep>
    );
};

Language.propTypes = {
    formModuleDisplay: PropTypes.object.isRequired,
    setFormModuleDisplay: PropTypes.func.isRequired,
    languages: PropTypes.array.isRequired
};

export default Language;
